<div class="stepper-container">
  @for (step of getSteps(); track step) {
    <button class="stepper-button" (click)="onStepClick.emit(step)">
      @if (step === currentStep()) {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="4"
          viewBox="0 0 32 4"
          fill="none"
          class="step-active"
        >
          <path
            d="M0 2C0 0.895431 0.895431 0 2 0H30C31.1046 0 32 0.895431 32 2C32 3.10457 31.1046 4 30 4H2C0.895431 4 0 3.10457 0 2Z"
          />
        </svg>
      } @else {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="4"
          viewBox="0 0 12 4"
          fill="none"
          [ngClass]="{
            'step-inactive': step > currentStep(),
            'step-active': step < currentStep(),
          }"
        >
          <path
            d="M0 2C0 0.895431 0.895431 0 2 0H10C11.1046 0 12 0.895431 12 2C12 3.10457 11.1046 4 10 4H2C0.895431 4 0 3.10457 0 2Z"
          />
        </svg>
      }
    </button>
  }
</div>
